import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";

import AddIcon from "@mui/icons-material/Add";
import GroupIcon from "@mui/icons-material/Groups";

import { SnackContext } from "context/SnackProvider";
import instance, { GetUserRole, getErrorMessage } from "api/definitions";
import PageContainer from "components/templates/PageContainer";
import ResourceTable from "components/molecules/table/ResourceTable";
import InfoTooltip from "components/atoms/info/InfoTooltip";

const sortListByName = (currentList) => {
  const newList = [...currentList].sort((a, b) => {
    return a.nome.localeCompare(b.nome);
  });
  return newList;
};

const ResourceTableList = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setItems([]);
    setIsLoaded(false);

    instance
      .get("recurso")
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        const newResult = sortListByName(result);
        setItems(newResult);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [props, snackContext]);

  if (!isLoaded) {
    return <CircularProgress />;
  } else {
    if (items.length === 0) {
      return (
        <Typography sx={{ color: "error.main" }}>
          Não há nenhum usuário cadastrado.
        </Typography>
      );
    } else {
      return <ResourceTable rows={items} />;
    }
  }
};

const Fields = () => {
  const navigate = useNavigate();
  const userRole = GetUserRole();

  const handleClickNewUser = () => {
    navigate("/usuario-novo");
  };

  return (
    <>
      <Box id="boxData" sx={{ mt: 2 }}>
        <ResourceTableList />
      </Box>
      {userRole > 5 && (
        <Box
          id="boxData"
          sx={{ position: "absolute", top: "14%", right: "10%" }}
        >
          <InfoTooltip title="Novo recurso" placement="left">
            <Fab
              size="medium"
              color="primary"
              aria-label="novo usuario"
              onClick={handleClickNewUser}
            >
              <AddIcon />
            </Fab>
          </InfoTooltip>
        </Box>
      )}
    </>
  );
};

const UserList = () => {
  return (
    <PageContainer maxWidth="lg" title={"Usuários"} icon={<GroupIcon />}>
      <Fields />
    </PageContainer>
  );
};

export default UserList;
